/* global SWAGGER_URI_V1, SWAGGER_URI_V2, CLIENT_ID */

import SwaggerUIBundle from 'swagger-ui';
import SwaggerUIStandalonePreset from 'swagger-ui/dist/swagger-ui-standalone-preset';

require('swagger-ui/dist/swagger-ui.css');
require('swagger-ui/dist/oauth2-redirect.html');

// var apiPreset = SwaggerUI.presets.ApiPreset;

const ui = SwaggerUIBundle({
  dom_id: '#swagger-ui',
  validatorUrl: null,
  presets: [
    SwaggerUIBundle.presets.apis,
    SwaggerUIStandalonePreset,
  ],
  plugins: [
    SwaggerUIBundle.plugins.DownloadUrl,
  ],
  layout: 'StandaloneLayout',
  urls: [
    { url: SWAGGER_URI_V1, name: 'v1' },
    { url: SWAGGER_URI_V2, name: 'v2' },
  ],
  'urls.primaryName': 'v1',
  docExpansion: 'none',
  tagsSorter: 'alpha',
  deepLinking: true,
  displayRequestDuration: true,
  operationsSorter: 'alpha',
  oauth2RedirectUrl: `${window.location.protocol}//${window.location.host}/explore/oauth2-redirect.html`,
});

ui.initOAuth({
  clientId: CLIENT_ID,
  additionalQueryStringParams: { audience: SWAGGER_URI_V1.replace(/\/explore.*$/, '/') },
});
